export default __webpack_public_path__ + "static/media/adoption.6b9b6556.svg";